import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
  //   FormRenderProps,
} from "@progress/kendo-react-form";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { clearFilter, setFilter } from "./shippingMovementsListSlice";
import { closeDialog } from "../../components/dialog/dialogSlice";
import FormMultiSelectionFiled from "../../components/formFields/FormMultiSelectionFiled";
import FormDatePicker from "../../components/formFields/FormDateField";
// import { applyContactFilter } from "./services/contact.services";
// import { findIndex } from "lodash";
import moment from "moment";
import { clearCurrentPage } from "../pagination/paginationSlice";
// import FormSelectionField from "../../components/formFields/FormSelectionField";
import { getAllShippingMovements } from "./services/shippingMovementsList.services";
import { getAllActiveAgent } from "../agent/services/agent.services";
import { getAllActiveNewPort } from "../newport/services/newport.services";
import { getAllActiveLine } from "../line/services/line.services";
import { IAgent } from "../agent/agentModel";
import { INewPort } from "../newport/newportModel";
import { ILine } from "../line/lineModel";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import { ErrorToast } from "../../components/toast/Toasts";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const FilterWatcher: React.FC<ChangeWatcherProps> = ({ formRenderProps }) => {
  const from_date_eta = formRenderProps.valueGetter("from_date_eta");
  const to_date_eta = formRenderProps.valueGetter("to_date_eta");
  const from_date_etd = formRenderProps.valueGetter("from_date_etd");
  const to_date_etd = formRenderProps.valueGetter("to_date_etd");

  useEffect(() => {
    if (to_date_eta || to_date_etd) {
      console.log("from_date_eta < to_date_eta", from_date_eta < to_date_eta);

      if (from_date_eta > to_date_eta) {
        formRenderProps.onChange("to_date_eta", { value: null });
      }
      if (from_date_etd > to_date_etd) {
        formRenderProps.onChange("to_date_etd", { value: null });
      }
    }
  }, [from_date_eta, from_date_etd]);

  return null;
};

const SMFilter: React.FC = () => {
  useEffect(() => {
    dispatch(getAllActiveAgent());
    dispatch(getAllActiveNewPort());
    dispatch(getAllActiveLine());
  }, []);
  const dispatch = useAppDispatch();
  const [formKey, setFormKey] = React.useState(1);

  const { currentPage, pageLimit } = useAppSelector(
    (state: RootState) => state.pagination
  );
  const initialValues = useAppSelector(
    (state: RootState) => state.shippingMovementslist.filter
  );
  const dialogName = useAppSelector(
    (state: RootState) => state.dialog.dialogName
  );

  const AgentList = useAppSelector((state: RootState) => state.agent.AgentList);
  const PortList = useAppSelector(
    (state: RootState) => state.newport.NewPortList
  );
  const LineList = useAppSelector((state: RootState) => state.line.LineList);
  const isFilterSet = useAppSelector(
    (state: RootState) => state.shippingMovementslist.isFilterSet
  );

  const handleClearFilters = () => {
    if (isFilterSet) {
      dispatch(clearFilter());
      const data = {
        limit: pageLimit,
        skip: currentPage * pageLimit,
      };
      dispatch(getAllShippingMovements(data));
    }
    setFormKey(formKey + 1);
  };

  const handleSubmit = (values: any) => {
    if (values?.from_date_etd > values?.to_date_etd) {
      ErrorToast("ETD From Date Is Greater Than ETD To Date !");
      return;
    }

    if (values?.from_date_eta > values?.to_date_eta) {
      ErrorToast("ETA From Date Is Greater Than ETA To Date !");
      return;
    }

    const formdata = {
      shipping_movements: values?.shipping_movements,
      port_id: values?.port_id ? values?.port_id?.join(",") : "",
      // eta: values?.eta ? moment(values?.eta).format("YYYY-MM-DD") : "",
      to_date_etd: values?.to_date_etd
        ? moment(values?.to_date_etd).format("YYYY-MM-DD")
        : "",
      from_date_etd: values?.from_date_etd
        ? moment(values?.from_date_etd).format("YYYY-MM-DD")
        : "",
      to_date_eta: values?.to_date_eta
        ? moment(values?.to_date_eta).format("YYYY-MM-DD")
        : "",
      from_date_eta: values?.from_date_eta
        ? moment(values?.from_date_eta).format("YYYY-MM-DD")
        : "",
      cut_off_datetime: values?.cut_off_datetime
        ? moment(values?.cut_off_datetime).format("YYYY-MM-DD")
        : "",
      vessels_name: values?.vessels_name,
      voj_no: values?.voj_no,
      vcn: values?.vcn,
      line_id: values?.line_id ? values?.line_id?.join(",") : "",
      agent_id: values?.agent_id ? values?.agent_id?.join(",") : "",
      next_port_id: values?.next_port_id ? values?.next_port_id?.join(",") : "",
      will_load_for: values?.will_load_for,
      // etd: values?.etd ? moment(values?.etd).format("YYYY-MM-DD") : "",
      form_type: values?.form_type,
      limit: pageLimit,
      skip: currentPage * pageLimit,
    };
    dispatch(
      setFilter({
        shipping_movements: values?.shipping_movements,
        port_id: values?.port_id,
        from_date_eta: values?.from_date_eta,
        to_date_eta: values?.to_date_eta,
        cut_off_datetime: values?.cut_off_datetime,
        vessels_name: values?.vessels_name,
        voj_no: values?.voj_no,
        vcn: values?.vcn,
        line_id: values?.line_id,
        agent_id: values?.agent_id,
        next_port_id: values?.next_port_id,
        will_load_for: values?.will_load_for,
        from_date_etd: values?.from_date_etd,
        to_date_etd: values?.to_date_etd,
        form_type: values?.form_type,
        limit: pageLimit,
        skip: currentPage * pageLimit,
      })
    );
    dispatch(clearCurrentPage());
    dispatch(getAllShippingMovements(formdata))
      .unwrap()
      .then(() => {
        dispatch(closeDialog());
      })
      .catch(() => {
        dispatch(closeDialog());
      });
  };

  const FORMTYPE = [
    { label: "Shipping Management", value: "SHIPPING" },
    { label: "Container Import Discharge", value: "CONTAINER" },
    { label: "Vessel's Export Loading", value: "VESSELS" },
  ];
  return (
    <>
      {dialogName === "SMFilter" && (
        <AppDialog>
          <Form
            key={formKey}
            onSubmit={handleSubmit}
            initialValues={initialValues}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "40vw" }}>
                <Typography.h5 style={{ margin: 0 }}>{"Filter"}</Typography.h5>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ cols: 10, rows: 0 }}
                  cols={[{ width: "50%" }, { width: "50%" }]}
                >
                  <FilterWatcher formRenderProps={formRenderProps} />
                  <GridLayoutItem>
                    <Field
                      name="from_date_eta"
                      label="ETA From"
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="to_date_eta"
                      label="ETA To"
                      disabled={
                        formRenderProps.valueGetter("from_date_eta")
                          ? false
                          : true
                      }
                      validator={
                        formRenderProps.valueGetter("from_date_eta")
                          ? requiredValidator
                          : undefined
                      }
                      minDate={formRenderProps.valueGetter("from_date_eta")}
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="form_type"
                      label="Type"
                      placeholder="Select Type"
                      options={FORMTYPE.map((form: any) => {
                        return {
                          value: form.value,
                          label: form.label,
                        };
                      })}
                      component={FormSelectionField}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="cut_off_datetime"
                      label="Cut Off Date"
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="vessels_name"
                      label="Vessel's Name"
                      placeholder="Vessel's Name"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="voj_no"
                      label="VOY No"
                      placeholder="VOY No"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="vcn"
                      label="VCN No"
                      placeholder="VCN No"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="will_load_for"
                      label="Will Load For"
                      placeholder="Will Load For"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="agent_id"
                      label="Agent"
                      placeholder="Select Agent"
                      options={AgentList.map((agent: IAgent) => {
                        return {
                          value: agent.id,
                          label: agent.agent_name,
                        };
                      })}
                      component={FormMultiSelectionFiled}
                    />
                  </GridLayoutItem>

                  <GridLayoutItem>
                    <Field
                      name="port_id"
                      label="Port"
                      placeholder="Select Port"
                      options={PortList.map((port: INewPort) => {
                        return {
                          value: port.id,
                          label: port.port_name,
                        };
                      })}
                      component={FormMultiSelectionFiled}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="line_id"
                      label="Line"
                      placeholder="Select Line"
                      options={LineList.map((line: ILine) => {
                        return {
                          value: line.id,
                          label: line.line_name,
                        };
                      })}
                      component={FormMultiSelectionFiled}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="next_port_id"
                      label="Next Port"
                      placeholder="Select Port"
                      options={PortList.map((port: INewPort) => {
                        return {
                          value: port.id,
                          label: port.port_name,
                        };
                      })}
                      component={FormMultiSelectionFiled}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="from_date_etd"
                      label="ETD From"
                      component={FormDatePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="to_date_etd"
                      label="ETD To"
                      disabled={
                        formRenderProps.valueGetter("from_date_etd")
                          ? false
                          : true
                      }
                      minDate={formRenderProps.valueGetter("from_date_etd")}
                      component={FormDatePicker}
                      validator={
                        formRenderProps.valueGetter("from_date_etd")
                          ? requiredValidator
                          : undefined
                      }
                    />
                  </GridLayoutItem>
                  {/* <FilterWatcher formRenderProps={formRenderProps} /> */}
                  <GridLayoutItem
                    colSpan={2}
                    style={{
                      height: "50px",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "end",
                    }}
                  >
                    <DialogCloseButton text="Cancel" />
                    <Button
                      style={{
                        marginRight: 8,
                        marginLeft: 4,
                      }}
                      onClick={handleClearFilters}
                      type="button"
                      themeColor={"primary"}
                      fillMode="outline"
                    >
                      Clear
                    </Button>
                    <Button
                      fillMode={"solid"}
                      themeColor={"primary"}
                      type="submit"
                    >
                      Apply
                    </Button>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </AppDialog>
      )}
    </>
  );
};

export default SMFilter;
